// Mock data for Orthodontic Clinic Website

export const clinicInfo = {
  name: "SmileCraft Orthodontics",
  tagline: "Creating Beautiful Smiles",
  phone: "(555) 123-4567",
  email: "hello@smilecraftortho.com",
  address: "1234 Dental Avenue, Suite 200",
  city: "Beverly Hills, CA 90210",
  hours: {
    weekdays: "Mon - Fri: 8:00 AM - 6:00 PM",
    saturday: "Sat: 9:00 AM - 3:00 PM",
    sunday: "Sun: Closed"
  },
  social: {
    facebook: "https://facebook.com/smilecraftortho",
    instagram: "https://instagram.com/smilecraftortho",
    twitter: "https://twitter.com/smilecraftortho"
  }
};

export const services = [
  {
    id: 1,
    title: "Traditional Braces",
    description: "Classic metal braces with modern comfort. Effective treatment for all ages with reliable, time-tested results.",
    icon: "braces",
    features: ["Affordable option", "Effective for complex cases", "Various color options"]
  },
  {
    id: 2,
    title: "Invisalign",
    description: "Clear, removable aligners for a virtually invisible treatment. Perfect for adults and teens seeking discretion.",
    icon: "aligners",
    features: ["Nearly invisible", "Removable for eating", "Comfortable fit"]
  },
  {
    id: 3,
    title: "Ceramic Braces",
    description: "Tooth-colored brackets that blend with your smile. All the effectiveness of traditional braces with enhanced aesthetics.",
    icon: "ceramic",
    features: ["Less visible", "Stain-resistant", "Strong & durable"]
  },
  {
    id: 4,
    title: "Retainers",
    description: "Custom-made retainers to maintain your perfect smile. Essential for long-lasting orthodontic results.",
    icon: "retainer",
    features: ["Custom fitted", "Multiple types available", "Easy maintenance"]
  },
  {
    id: 5,
    title: "Early Treatment",
    description: "Interceptive orthodontics for children. Address developing issues early for better long-term outcomes.",
    icon: "child",
    features: ["Ages 7-10", "Prevent future issues", "Guide jaw growth"]
  },
  {
    id: 6,
    title: "Surgical Orthodontics",
    description: "Comprehensive treatment for severe cases. Combining orthodontics with oral surgery for optimal results.",
    icon: "surgery",
    features: ["Complex cases", "Jaw alignment", "Life-changing results"]
  }
];

export const doctors = [
  {
    id: 1,
    name: "Dr. Sarah Mitchell",
    title: "Lead Orthodontist",
    credentials: "DDS, MS in Orthodontics",
    bio: "With over 15 years of experience, Dr. Mitchell specializes in creating beautiful smiles using the latest orthodontic techniques. She completed her orthodontic residency at UCLA and is a member of the American Association of Orthodontists.",
    image: "https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=400&h=400&fit=crop&crop=face"
  },
  {
    id: 2,
    name: "Dr. James Chen",
    title: "Orthodontist",
    credentials: "DMD, Certified Invisalign Provider",
    bio: "Dr. Chen brings a passion for cutting-edge technology to orthodontics. An Invisalign Diamond Provider, he has transformed thousands of smiles with clear aligner therapy and is dedicated to patient comfort.",
    image: "https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=400&h=400&fit=crop&crop=face"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Emily Rodriguez",
    treatment: "Invisalign",
    rating: 5,
    text: "I was nervous about getting braces as an adult, but Dr. Mitchell recommended Invisalign and it changed everything! No one even noticed I was straightening my teeth. The results are amazing!",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=face"
  },
  {
    id: 2,
    name: "Michael Thompson",
    treatment: "Traditional Braces",
    rating: 5,
    text: "My son had a great experience here. The staff made him feel comfortable and the results exceeded our expectations. Highly recommend SmileCraft for families!",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=face"
  },
  {
    id: 3,
    name: "Jessica Park",
    treatment: "Ceramic Braces",
    rating: 5,
    text: "The ceramic braces were perfect for me - effective but discreet. Dr. Chen was wonderful and always answered my questions. My smile has never looked better!",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop&crop=face"
  },
  {
    id: 4,
    name: "David Martinez",
    treatment: "Invisalign",
    rating: 5,
    text: "Professional, friendly, and truly experts in their field. The entire process from consultation to final result was smooth. Thank you for my new smile!",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&h=100&fit=crop&crop=face"
  }
];

export const beforeAfter = [
  {
    id: 1,
    treatment: "Invisalign - 14 months",
    before: "https://images.unsplash.com/photo-1606811841689-23dfddce3e95?w=300&h=200&fit=crop",
    after: "https://images.unsplash.com/photo-1606811971618-4486d14f3f99?w=300&h=200&fit=crop"
  },
  {
    id: 2,
    treatment: "Traditional Braces - 18 months",
    before: "https://images.unsplash.com/photo-1606811841689-23dfddce3e95?w=300&h=200&fit=crop",
    after: "https://images.unsplash.com/photo-1606811971618-4486d14f3f99?w=300&h=200&fit=crop"
  },
  {
    id: 3,
    treatment: "Ceramic Braces - 16 months",
    before: "https://images.unsplash.com/photo-1606811841689-23dfddce3e95?w=300&h=200&fit=crop",
    after: "https://images.unsplash.com/photo-1606811971618-4486d14f3f99?w=300&h=200&fit=crop"
  }
];

export const faqs = [
  {
    id: 1,
    question: "How long does orthodontic treatment typically take?",
    answer: "Treatment duration varies based on individual needs, but most cases range from 12-24 months. During your consultation, we'll provide a personalized timeline based on your specific situation."
  },
  {
    id: 2,
    question: "At what age should my child first see an orthodontist?",
    answer: "The American Association of Orthodontists recommends children have their first orthodontic evaluation by age 7. Early detection allows us to guide jaw growth and address developing issues before they become more complex."
  },
  {
    id: 3,
    question: "Is Invisalign as effective as traditional braces?",
    answer: "Yes! Invisalign can effectively treat most orthodontic cases. However, some complex cases may benefit more from traditional braces. We'll recommend the best option during your consultation."
  },
  {
    id: 4,
    question: "How much does orthodontic treatment cost?",
    answer: "Treatment costs vary based on the type and duration of treatment needed. We offer flexible payment plans and work with most insurance providers. Contact us for a free consultation and cost estimate."
  },
  {
    id: 5,
    question: "Does getting braces hurt?",
    answer: "You may experience mild discomfort for a few days after braces are placed or adjusted. This is normal and can be managed with over-the-counter pain relievers. Most patients adapt quickly!"
  },
  {
    id: 6,
    question: "How often will I need appointments?",
    answer: "Typically, you'll visit us every 4-8 weeks for adjustments and progress checks. Invisalign patients may have slightly fewer visits since aligners are changed at home."
  }
];

export const insuranceProviders = [
  "Delta Dental",
  "Cigna",
  "Aetna",
  "MetLife",
  "United Healthcare",
  "Blue Cross Blue Shield",
  "Guardian",
  "Humana"
];

export const paymentOptions = [
  {
    title: "Insurance",
    description: "We accept most major dental insurance plans and will help maximize your benefits."
  },
  {
    title: "Flexible Financing",
    description: "0% interest payment plans available. Spread your treatment cost over convenient monthly payments."
  },
  {
    title: "FSA/HSA",
    description: "Use your Flexible Spending Account or Health Savings Account for orthodontic treatment."
  },
  {
    title: "Family Discounts",
    description: "Special discounts available when multiple family members receive treatment."
  }
];
